import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-order-cust-com',
  templateUrl: './order-cust-com.component.html',
  styleUrls: ['./order-cust-com.component.css']
})
export class OrderCustComComponent implements OnInit {
    orderCustComKeyno;

    public orderButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'orderhead', gotoParms: () => this.edit!.order_internal_no ?? '' }];

    public statCustNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'customersmenu', gotoParms: () => this.edit!.cust_no ?? '' }];

    public edit?: Edit;
    
    public saving = false;
    
    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.orderCustComKeyno = this.stateService.getStateParams()['ordercustcom_keyno'];
    }

    private async loadEdit() {
        if (!!this.orderCustComKeyno) {
            this.edit = (await this.datatask.Post(2350, { ordercustcom_keyno: this.orderCustComKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2351, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    ordercustcom_keyno: string;
    is_communicated: string;
    remarks: string;
    reg_datetime: string;
    mod_datetime: string;
    mod_by_portal_user_keyno: string;
    mod_by_portal_user_name: string;
    deliverydate: string;
    order_order_no: string;
    order_internal_no: string;
    cust_no: string;
    stat_cust_name: string;
    cust_telephone: string;
}
